import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";

const Component: FunctionComponent<ContentSchemaRenderProps> = ({ schemaNode }) => (
  <>{schemaNode?.data}</>
);

Component.displayName = "Text";
export const Text = styled(Component)``;
